import z from 'zod'

import { RegisterFormFields } from '@/legacy-src/components/register/types'
import { PASSWORD_FIELD_MIN_LENGTH } from '@/legacy-src/constants/storage'
import { phone } from '@/legacy-src/lib/zod/phone'

export const validationRegisterSchema = z.object({
  [RegisterFormFields.email]: z
    .string()
    .email('validationErrors.email.badEmailFormat')
    .nonempty('validationErrors.required'),
  [RegisterFormFields.password]: z
    .string()
    .min(PASSWORD_FIELD_MIN_LENGTH, 'validationErrors.badPasswordFormat')
    .nonempty('validationErrors.required'),
  [RegisterFormFields.gdpr]: z.boolean().refine((val) => val === true, {
    message: 'validationErrors.notChecked',
  }),
  [RegisterFormFields.phone]: phone(z.string().optional(), 'validationErrors.badPhoneFormat'),
})
